import Provider from "./new/provider";
import {Constructor} from "../../global/constructor";
import {IServerData} from "../interfaces/serverInterfaces";
import {HTTPMethod} from "./new/httpMethod";
import {RouteHelper} from "../helpers/routeHelper";
import {Route} from "../enums/route";
import Visualization from "~/models/visualizations/visualization";
import { IProviderRoutes } from "~/interfaces/provider";

interface IVisualizationProviderRoutes {
  getForm: Route;
  publish: Route;
  show: Route;
}

export default class VisualizationProvider<T extends Visualization = Visualization> extends Provider<T> {
  routes: IProviderRoutes & IVisualizationProviderRoutes;

  constructor(
    protected modelType: Constructor<T>,
    public modelRoot: string,
    public collectionRoot: string
  ) {
    super(modelType, modelRoot, collectionRoot);
    let newRoutes: IVisualizationProviderRoutes = {
      getForm: Route.editForm,
      publish: Route.publishVisualization,
      show: Route.visualizationShow
    };
    Object.assign(this.routes, newRoutes);
  }

  getForm(id: string): Promise<IServerData<any>> {
    return new Promise<IServerData>((resolve, reject) => {
      this.serverAction({
        endpoint: RouteHelper.path({route: this.routes.getForm, modelOrId: id}),
        method: HTTPMethod.GET,
        json: {}
      }).then(resolve);
    });
  }

  publish(visualization: Visualization): Promise<IServerData> {
    return new Promise<IServerData>((resolve, reject) => {
      this.serverAction({
        endpoint: RouteHelper.path({
          route: this.routes.publish,
          modelOrId: visualization
        }),
        method: HTTPMethod.POST
      }).then(resolve);
    });
  }
}